@use "styles" as *;

$block: me-navbar;

.#{$block} {
  display: grid;
  grid-template-areas:
    "start-actions end-actions"
    "body body";
  align-items: center;
  padding: $me-navbar-padding-vertical $me-navbar-padding-horizontal;
  box-shadow: $box-shadow;
  background-color: $color-background-contrast;

  &--animated {
    transition: transform $transition-timing;
  }

  &--hidden {
    transform: translateY(-100%);
  }

  &__logo {
    grid-area: start-actions / start-actions / end-actions / end-actions;
    justify-self: center;
    z-index: 10100;
    display: flex;
    align-items: center;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent 0%,
        $color-background-contrast 5%,
        $color-background-contrast 95%,
        transparent 100%
    );
    padding: space(0, 4);
    cursor: pointer;

    svg {
      height: 20px;
      width: auto;
      color: $color-logo;
    }
  }

  &__actions, &__actions [slot] {
    display: flex;
    align-items: center;
  }

  &__actions {
    &--start, &--start [slot] {
      gap: space(2);
    }

    &--start {
      grid-area: start-actions;
      justify-self: flex-start;

      .me-button--link:first-child {
        margin-left: -$me-navbar-padding-horizontal;
      }
    }

    &--end {
      grid-area: end-actions;
      justify-self: flex-end;
    }

    .me-button.me-button--link {
      padding: space(2);
    }
  }

  &__back-button-label {
    font-size: $font-size-s;
  }

  &__back-button .me-button__label {
    display: flex;
    align-items: center;
    gap: space(1);
  }

  &__menu-button {
    margin-right: -$me-navbar-padding-horizontal;

    &.me-button.me-button--link {
      padding: space(2) $me-navbar-padding-horizontal space(2) space(2);
    }

    svg {
      display: block;
      height: 1em;
      width: auto;
    }
  }

  &__body {
    grid-area: body;
    justify-self: stretch;

    [slot=body] {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: space(5);
      border-top: 1px solid $color-gray-200;
      margin-top: $me-navbar-padding-vertical;
      padding: $me-navbar-padding-vertical $me-navbar-padding-horizontal 0;
      text-transform: uppercase;
      font-size: $font-size-s;

      &:empty {
        display: none;
      }
    }

    @include media-breakpoint-down(md) {
      display: none;
    }
  }
}
